import { render } from "./AppFileUpload.vue?vue&type=template&id=5b99c728&scoped=true"
import script from "./AppFileUpload.vue?vue&type=script&lang=js"
export * from "./AppFileUpload.vue?vue&type=script&lang=js"

import "./AppFileUpload.vue?vue&type=style&index=0&id=5b99c728&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b99c728"]])

export default __exports__